// RUN_AI_PROCESS / SEND_AI_PROCESS_RESULTS loan actions. Process, provider and tag ids round-trip as raw
// ids, so a saved action keeps them even when the AI process, provider or tag lists are not loaded.
// Actions saved before the completion tags existed read with no tags and RerunOnTrigger off.

import { LoanEditorActionsEnum } from 'constants/loanActionEditor';

const getIdOrNull = value => value || null;

export const getAiProcessActionApiFormat = (formItem, common) => {
  if (common.type === LoanEditorActionsEnum.SEND_AI_PROCESS_RESULTS) {
    const item = formItem.sendAiProcessResults ?? {};

    return {
      ...common,
      processId: getIdOrNull(item.processId),
      providerKey: getIdOrNull(item.providerKey),
      postedTagId: getIdOrNull(item.postedTagId),
      failedTagId: getIdOrNull(item.failedTagId),
    };
  }

  const item = formItem.runAiProcess ?? {};

  return {
    ...common,
    processId: getIdOrNull(item.processId),
    completedTagId: getIdOrNull(item.completedTagId),
    awaitingConfirmationTagId: getIdOrNull(item.awaitingConfirmationTagId),
    failedTagId: getIdOrNull(item.failedTagId),
    rerunOnTrigger: item.rerunOnTrigger === true,
  };
};

export const getRunAiProcessFormFormat = (actionItem, itemType, timedSequenceOptions) => ({
  itemType,
  timedSequenceOptions,
  runAiProcess: {
    processId: getIdOrNull(actionItem.processId),
    completedTagId: getIdOrNull(actionItem.completedTagId),
    awaitingConfirmationTagId: getIdOrNull(actionItem.awaitingConfirmationTagId),
    failedTagId: getIdOrNull(actionItem.failedTagId),
    rerunOnTrigger: actionItem.rerunOnTrigger === true,
  },
});

export const getSendAiProcessResultsFormFormat = (actionItem, itemType, timedSequenceOptions) => ({
  itemType,
  timedSequenceOptions,
  sendAiProcessResults: {
    processId: getIdOrNull(actionItem.processId),
    providerKey: getIdOrNull(actionItem.providerKey),
    postedTagId: getIdOrNull(actionItem.postedTagId),
    failedTagId: getIdOrNull(actionItem.failedTagId),
  },
});
